module.exports = __webpack_public_path__ + "static/media/carousel2.d7003af0.png";